import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, take } from 'rxjs';
import { Units } from '@app/models/units.model';
import { AdminRestService } from '@services/rest/admin-rest.service';
import { CurrentUnitsService } from '@services/current-units.service';
import { TemplateConstants } from '../constants/template-constants';
import { TranslocoService } from '@jsverse/transloco';
import { ToastServiceManager } from '@app/services/toast-service-manager.service';

@Component({
  selector: 'app-organization-settings',
  templateUrl: './organization-settings.component.html',
  styleUrl: './organization-settings.component.scss',
  standalone: false,
})
export class OrganizationSettingsComponent implements OnInit {
  public OrganizationSettingsForm!: FormGroup;
  public IsSubmitting: boolean = false;
  public readonly Units!: Units[];
  public readonly UnitsText!: string[]
  private readonly ToastService!: ToastServiceManager;

  constructor(
    private readonly adminApi: AdminRestService,
    private readonly currentUnitsService: CurrentUnitsService,
    private readonly transloco: TranslocoService,
    private readonly toastService: ToastServiceManager
  ) {
    this.Units = [Units.Foot, Units.Meter];
    this.UnitsText = [TemplateConstants.Units[0], TemplateConstants.Units[1]];
    this.ToastService = toastService;
  }

  ngOnInit(): void {
    this.transloco.selectTranslate(['Units.foot', 'Units.meter']).subscribe(results => {
      this.UnitsText[0] = results[0];
      this.UnitsText[1] = results[1];
    });
    this.OrganizationSettingsForm = new FormGroup({
      defaultUnits: new FormControl<Units>(this.currentUnitsService.getCurrentUnits(), {
        nonNullable: true,
        validators: [Validators.required],
      }),
    });
  }

  public onSubmit(): void {
    if (this.OrganizationSettingsForm.invalid || this.IsSubmitting) {
      return;
    }
    this.IsSubmitting = true;
    const units = this.OrganizationSettingsForm.get('defaultUnits')!.value;
    this.adminApi.updateDefaultUnits(units).pipe(
      take(1),
      finalize(() => {
        this.IsSubmitting = false;
      }),
    ).subscribe({
      next: () => {
        this.ToastService.success(this.transloco.translate('OrganizationSettings.defaultUnitsUpdated'), undefined, {closeButton: true});
      }
    });
  }
}
